module.exports = __webpack_public_path__ + "img/gu.64936a10.svg";